import { jsx as _jsx } from "react/jsx-runtime";
import useFeaturedContentData from "../../../hooks/useFeaturedContentData";
import FeaturedDataElement from "../../atoms/FeaturedDataElement";
var PrimaryFeaturedContent = function () {
    var _a = useFeaturedContentData(), hasMeter = _a.hasMeter, primary = _a.primary;
    if (!primary || hasMeter) {
        return _jsx("div", {});
    }
    var additionalLabel = primary.additionalLabel, label = primary.label, toolTipText = primary.toolTipText, type = primary.type, value = primary.value;
    return (_jsx(FeaturedDataElement, { additionalLabel: additionalLabel, dataCy: "primary-featured-content.data-element", label: label, isLargerText: true, toolTipText: toolTipText, type: type, value: value }));
};
export default PrimaryFeaturedContent;
//# sourceMappingURL=PrimaryFeaturedContent.js.map